import { PointerSensor, type PointerActivationConstraint } from '@dnd-kit/core';

// Custom sensor that ignores drag when clicking on buttons or resize handles
export class SmartPointerSensor extends PointerSensor {
  static activators = [
    {
      eventName: 'onPointerDown' as const,
      handler: (
        { nativeEvent }: { nativeEvent: globalThis.PointerEvent },
        { activationConstraint }: { activationConstraint?: PointerActivationConstraint }
      ) => {
        const target = nativeEvent.target as HTMLElement;
        if (target.closest('button, [data-no-drag]')) return false;
        return true;
      },
    },
  ];
}
